import { Typology } from './typology.enum'
import {
  EntryPoint,
  AGROEntryPoint,
  JDEEntryPoint
} from '@app/shared/entry-points/models/entry-point.model'

export class TraceabilityRequest {
  entries: EntryPoint[]

  typology: Typology

  constructor(request?: Partial<TraceabilityRequest>) {
    this.entries = request.entries || []
    this.typology = request.typology || Typology.upstream

    this.entries = this.entries.map((e) => {
      if (e.type === 'AGRO') {
        return new AGROEntryPoint(e as AGROEntryPoint)
      } else {
        return new JDEEntryPoint(e as JDEEntryPoint)
      }
    })
  }
}
